module.exports = __webpack_public_path__ + "static/3-fa41a24b56973effc987c9946fa3ad4e.jpeg";